import React, { createContext, useContext, useState, useMemo } from 'react';
import * as en from './content.en';
import * as es from './content.es';

const STORAGE_KEY = 'qubo_lang';
const DEFAULT_LANG = 'en';
const dictionaries = { en, es };

const LanguageContext = createContext(null);

const getInitialLang = () => {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored === 'en' || stored === 'es' ? stored : DEFAULT_LANG;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitialLang);

  const setLang = (nextLang) => {
    setLangState(nextLang);
    window.localStorage.setItem(STORAGE_KEY, nextLang);
  };

  const value = useMemo(() => ({ lang, setLang, content: dictionaries[lang] }), [lang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
